import React, {useContext, useMemo} from "react";
import classnames from "classnames";
import LazyImage from "../../../../../../../../components/app-specific/lazy-image";
import {UserHomepageControllerContext} from "../../../../../../index";
import {UserHomepageEventEmitter, UserHomepageViewMode} from "../../../../../../models";
import {Fade, Tooltip} from "@mui/material";

const UserWebHomepageCategories = ({component, tabId, viewMode}) => {
    const controller = useContext(UserHomepageControllerContext);
    const categories = useMemo(() => component?.content?.categories ?? [], [component])

    /** @type{boolean} */
    const showMoreButton = useMemo(() => true, [])
    /** @type{boolean}*/
    const moreButtonInvisible = useMemo(() => false, [])

    /**
     * Invokes the appropriate controller callback for the click of the categories more button.
     */
    const onMoreButtonClicked = () => {
        if (viewMode === UserHomepageViewMode.preview)
            return;
        controller.selectComponentSearchButton(tabId, component.id, UserHomepageEventEmitter.view);
    }

    /**
     * Invokes the appropriate controller callback for the click of a category.
     * @param category
     */
    const onCategoryClicked = (category) => {
        controller.clickContent(tabId, component.id, category.id, UserHomepageEventEmitter.view);
    }

    /**@type {JSX.Element}*/
    const moreButton = useMemo(() => (
        <button
            onClick={onMoreButtonClicked}
            className={classnames('user-web-homepage-more-button', {'not-visible': moreButtonInvisible})}>
            See All
        </button>
    ), [moreButtonInvisible])

    return (
        <>
            <div className={'user-web-homepage-categories'}>
                <div className={'user-web-homepage-block-header component-title'}>
                    <p>
                        {component?.title ?? ''}
                    </p>
                    <div>
                        <Fade in={showMoreButton}>
                            {
                                moreButtonInvisible
                                    ? <Tooltip title={'No search query or search type specified'}>
                                        {moreButton}
                                    </Tooltip>
                                    : viewMode === UserHomepageViewMode.preview
                                        ? <Tooltip title={"Users will see the list of categories by clicking on the" +
                                            " more button"}>
                                            {moreButton}
                                        </Tooltip>
                                        : moreButton
                            }
                        </Fade>
                    </div>
                </div>
                <div className={'user-web-homepage-categories-grid'}>
                    {
                        categories.map((category) => (
                            <div key={category?.id}
                                 className={'user-web-homepage-category-card-container'}>
                                <div
                                    id={category.webViewElementId}
                                    onClick={() => onCategoryClicked(category)}
                                    className={'user-web-homepage-category-card'}
                                >
                                    <div className={'title-wrapper'}>
                                        <p className={'title'}>
                                            {category?.title ?? ''}
                                        </p>
                                    </div>
                                    <div className={'image'}>
                                        <LazyImage
                                            src={category?.coverFileName}
                                            alt={category?.coverFileName ?? ''}
                                            onContextMenu={(e) => e.preventDefault()}
                                            onDragStart={(e) => e.preventDefault()}
                                            className={'disable-downloading-image'}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </>
    );
}


export default UserWebHomepageCategories;
